import { createSelector } from '@reduxjs/toolkit';

import type { SliceStateFromReducer } from 'shared/types';

import type { persistedStoreSlice } from './persistedStore.model';

type TPersistedStoreStore = SliceStateFromReducer<typeof persistedStoreSlice>;

const persistedStoreSelector = (state: TPersistedStoreStore) => state.persistedStore;

export const isRestoredByPersistedStoreSelector = createSelector(
  persistedStoreSelector,
  (state) => state.isRestoredByPersistedStore,
);
